<template>
  <!-- Adding New Department for Company and Its Modal Popup -->
  <div>
    <modal
      class="new-modal-small"
      :name="modal_name"
      transition="nice-modal-fade"
      :delay="100"
      height="auto"
      :min-height="200"
      :min-width="400"
      :pivot-y="0.5"
      :adaptive="true"
      :scrollable="false"
      style="pointer-events:inherit !important" 
      v-bind:click-to-close="false"
    >
      <div class="v-modal-content" style="background-color: #eff1f4 !important;">
        <div class="v-modal-header">
          <div>
            <span class="v-modal-dialog-title v-modal-title headerPositionSmall">ADD NEW DEPARTMENT</span>
          </div>
          <div>
            <span class="icon icon-close mr-2 text-lightblack pointer" @click="hideDepartmentNew()"></span>
          </div>
        </div>
        <div class="v-modal-body">
          <div class="v-modal-layout">
            <div
              class="py-4 mb-4 text-center d-flex flex-column"
              style="border-bottom: 0.5px solid #a9aaad"
            >
              <span style="font-weight: 600">
                Company Name :
                <span style="font-weight: 400">{{ company_name }}</span>
              </span>
              <span style="font-weight: 600">
                Branch Name :
                <span style="font-weight: 400">{{ branch_name }}</span>
              </span>
            </div>
            <div class="px-10">
              <div class="form-group">
                <input
                  class="inputField"
                  name="department_name"
                  v-validate="'required'"
                  v-model="name"
                  style="margin-top:5px;"
                  type="text"
                  placeholder="Enter Department Name"
                  required
                />
                <span class="inputBorder"></span>
                <label class="inputLabel fs-14 fw-600" style="top: 0px !important;">Department Name*</label>
              </div>
              <span
                class="invalid-feedback-form text-danger"
                style="text-transform: none !important;"
                v-show="errors.has('department_name')"
              >Department Name is Required</span>
              <div class="row mt-7 mb-3">
                <div class="col-lg-12 text-center">
                  <button
                    type="button"
                    class="btn btn-danger btn-smm mr-3"
                    @click="hideDepartmentNew()"
                    style="box-shadow: none;"
                  >CANCEL</button>
                  <button
                    type="button"
                    class="btn btn-success text-white btn-smm"
                    style="box-shadow: none;"
                    @click="saveDeparmentNew()"
                  >SAVE</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import { EventBus } from "./eventBus/nav-bar-event.js";
export default {
  data() {
    return {
      name: "",
    };
  },
  props: ["modal_name", "company_name", "branch_name"],
  methods: {
    hideDepartmentNew() {
      this.name = "";
      this.$modal.hide(this.modal_name);
      this.$emit("hideDepartment");
    },
    saveDeparmentNew() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit("saveDept", this.name);
          this.hideDepartmentNew();
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/DepartmentNewModal.vue